// import { NavigationActions, StackActions } from '@react-navigation/compat';
import { CommonActions } from "@react-navigation/native";

import {
  navigate as navigateMain,
  navigationRef,
  dispatch,
} from "../navigation";

import { StackActions as CustomStackActions } from "@react-navigation/routers";

let _navigator = navigationRef;

function setTopLevelNavigator(navigatorRef) {
  _navigator = navigatorRef;
}

function getNavigatorRef() {
  return _navigator;
}

function navigate(routeName, params, key) {
  if (navigationRef.current) {
    if (key)
      navigationRef.current.dispatch(
        CommonActions.navigate({
          name: routeName,
          params,
          key,
        }),
      );
    else navigateMain(routeName, params);
  } else {
    // nav isn't mounted
  }
}
function pop(count) {
  if (navigationRef.current) {
    navigationRef.current.dispatch(CustomStackActions.pop(count));
  }
}

function push(routeName, params, key) {
  if (navigationRef.current) {
    navigationRef.current.dispatch(CustomStackActions.push(routeName, params));
  } else {
  }
}

function getActiveRouteName(navigationState) {
  if (!navigationState) {
    return null;
  }
  const route = navigationState.routes[navigationState.index];
  // dive into nested navigators
  if (route.routes) {
    return getActiveRouteName(route);
  }
  return route.routeName;
}

function reset(state) {
  navigationRef.current &&
    navigationRef.current.dispatch(CommonActions.reset(state));
}

function replace(routeName, params) {
  if (_navigator.current) {
    navigationRef.current &&
      navigationRef.current.dispatch(
        CustomStackActions.replace(routeName, params),
      );
  } else {
  }
}

// add other navigation functions that you need and export them

export default {
  push,
  navigate,
  getActiveRouteName,
  setTopLevelNavigator,
  reset,
  _navigator,
  getNavigatorRef,
  replace,
  pop,
  dispatch,
};
